module.exports = __webpack_public_path__ + "assets/img/GSlogo.63941c45.png";